import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Badge } from "../ui/badge";
import { Car, Clock } from "lucide-react";

export const VehicleSelection = ({
  pricing,
  vehicleType,
  bookingType,
  hours,
  currentVehicle,
  flightNumber,
  flightArrivalTime,
  onVehicleChange,
  onHoursChange,
  onFieldChange
}) => {
  return (
    <Card className="dashboard-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Car className="h-5 w-5 text-primary" />
          Vehicle Selection
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {pricing && Object.entries(pricing).map(([key, vehicle]) => (
            <button
              key={key}
              type="button"
              onClick={() => onVehicleChange(key)}
              className={`p-4 rounded-xl border transition-all ${
                vehicleType === key 
                  ? "bg-primary/10 border-primary text-foreground" 
                  : "bg-secondary/30 border-white/5 text-muted-foreground hover:bg-secondary/50"
              }`}
              data-testid={`vehicle-${key}`}
            >
              <Car className={`h-6 w-6 mx-auto mb-2 ${vehicleType === key ? "text-primary" : ""}`} />
              <p className="text-sm font-medium">{vehicle.name}</p>
              <p className="text-xs opacity-70">{vehicle.capacity} pax</p>
              {bookingType === "transfer" ? (
                <p className="text-sm font-bold mt-1">${vehicle.base_price}</p>
              ) : (
                <p className="text-sm font-bold mt-1 text-accent">${vehicle.hourly_rate}/hr</p>
              )}
            </button>
          ))}
        </div>

        {bookingType === "transfer" && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
            <div className="space-y-2">
              <Label htmlFor="flight_number">Flight Number (Optional)</Label>
              <div className="relative">
                <Input
                  id="flight_number"
                  name="flight_number"
                  placeholder="e.g., QF123"
                  value={flightNumber}
                  onChange={onFieldChange}
                  className="bg-secondary/50 border-black/10"
                  data-testid="flight-input"
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="flight_arrival_time">Flight Arrival Time (Optional)</Label>
              <Input
                id="flight_arrival_time"
                name="flight_arrival_time"
                type="time"
                value={flightArrivalTime}
                onChange={onFieldChange}
                className="bg-secondary/50 border-black/10"
                data-testid="flight-time-input"
              />
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
